import { createContext, useContext } from "react";

// Optional: better default value to catch bugs early
const MyContext = createContext(undefined);

export function useMyContext() {
  const context = useContext(MyContext);
  
  if (context === undefined) {
    throw new Error(
      "useMyContext must be used inside a MyContext.Provider"
    );
  }
  
  return context;
}

export default MyContext;